import { Paper, styled } from "@mui/material";

export const CustomizedPaper = styled(Paper)({
  borderRadius: "12px",
  padding: "32px",
  maxWidth: "100%",
  marginBottom: "16px",
});
